import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { MultiColumn, MultiColumnGroup, MultiColumnItem } from 'foundations-components/transitional/components/MultiColumn';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getCopy = actionTypeBodyInfoKey => {
  switch (actionTypeBodyInfoKey) {
    case 'scheduleUnpublish':
      return {
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "baseSchedulingOptionsModal.body.buttons.scheduleUnpublish"
        }),
        nothingScheduledText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "baseSchedulingOptionsModal.body.nothingScheduled.scheduleUnpublish"
        })
      };
    case 'scheduleUpdate':
      return {
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "baseSchedulingOptionsModal.body.buttons.scheduleUpdate"
        }),
        nothingScheduledText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "baseSchedulingOptionsModal.body.nothingScheduled.scheduleUpdate"
        })
      };
    default:
      return {
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "baseSchedulingOptionsModal.body.buttons.schedulePublish"
        }),
        nothingScheduledText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "baseSchedulingOptionsModal.body.nothingScheduled.schedulePublish"
        })
      };
  }
};
const NothingScheduledControls = ({
  actionTypeBodyInfoKey,
  onScheduleClick
}) => {
  const {
    buttonText,
    nothingScheduledText
  } = getCopy(actionTypeBodyInfoKey);
  return /*#__PURE__*/_jsx(MultiColumn, {
    flush: true,
    children: /*#__PURE__*/_jsxs(MultiColumnGroup, {
      children: [/*#__PURE__*/_jsx(MultiColumnItem, {
        horizontalAlign: "left",
        verticalAlign: "middle",
        paddingInline: "200",
        children: /*#__PURE__*/_jsx(Button, {
          use: "tertiary",
          onClick: onScheduleClick,
          "data-test-id": "schedule",
          children: buttonText
        })
      }), /*#__PURE__*/_jsx(MultiColumnItem, {
        horizontalAlign: "left",
        verticalAlign: "middle",
        paddingInline: "200",
        children: nothingScheduledText
      })]
    })
  });
};
export default NothingScheduledControls;